import { Box, Card, CardActionsProps, CardContent, Grow, Stack, Tooltip, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { ImageFromServer } from '@/components/images/ImageFromServer';
import { DeckDTO } from '../../generated';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import EditIcon from '@mui/icons-material/Edit';
import { Visibility } from '@mui/icons-material';
import { pathMap } from '@/navigation/paths';
import { DeckImage } from './DeckImage';

export const DeckCard = (props: { deck: DeckDTO; isDeckCreator: boolean; isEditor: boolean; children?: ReactElement<CardActionsProps>; timeout: number }) => {
  const { deck, isDeckCreator, children, isEditor } = props;

  const navigate = useNavigate();

  return (
    <Grow in={true} timeout={props.timeout}>
      <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', borderWidth: 0, borderColor: 'primary.dark', borderStyle: 'solid' }} className="h-100">
        <CardContent sx={{ flex: 0.9 }} onClick={() => navigate(`${pathMap.Exercises}/${deck.id}`)}>
          <Stack sx={{ flexDirection: 'row', gap: 2 }}>
            <DeckImage deck={deck} width={150} />
            <Stack>
              <Typography variant="h6" sx={{ mt: 1 }} color="text.secondary" gutterBottom>
                {deck?.name}
              </Typography>
              <Typography sx={{ fontSize: 14, mt: 1 }} color="text.secondary" gutterBottom>
                Created by {!isDeckCreator ? deck?.creatorName : 'You'}
              </Typography>
              <Stack sx={{ mt: 1 }} direction="row">
                {isDeckCreator && (
                  <Tooltip title={`You are the creator of ${deck.name} and may modify the deck and its exercises and copy exercises from this deck to your other decks.`}>
                    <WorkspacePremiumIcon sx={{ mr: 1 }} />
                  </Tooltip>
                )}
                {isEditor && (
                  <Tooltip title={`You are allowed to edit ${deck.name} and copy exercises from this deck to your decks.`}>
                    <EditIcon sx={{ mr: 1 }} />
                  </Tooltip>
                )}
                {!isDeckCreator && !isEditor && (
                  <Tooltip title={`You may view ${deck.name} and copy exercises from this deck to your decks.`}>
                    <Visibility />
                  </Tooltip>
                )}
              </Stack>
            </Stack>
            <Stack sx={{ flex: 1 }}>
              <Typography sx={{ textAlign: 'end' }} variant="caption">
                Last updated at {deck.modificationTimestamp ? deck.modificationTimestamp : 'unknown'}
              </Typography>
            </Stack>
          </Stack>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2">{deck?.description || 'No Description'}</Typography>
          </Box>
        </CardContent>
        {children}
      </Card>
    </Grow>
  );
};
